<template>
	<div>

	</div>
</template>

<script>
    export default {
        name: "KappNachrichten"
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/KappNachrichten.vue